import { render, staticRenderFns } from "./NavbarItemLanguage.vue?vue&type=template&id=e43d5afe&scoped=true&"
import script from "./NavbarItemLanguage.vue?vue&type=script&lang=js&"
export * from "./NavbarItemLanguage.vue?vue&type=script&lang=js&"
import style0 from "./NavbarItemLanguage.vue?vue&type=style&index=0&id=e43d5afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43d5afe",
  null
  
)

export default component.exports